/* MMW multi-wall: let a client add several walls to one project on the same page.
   "Add another wall" snapshots the current wall (size, finish, panels, current total) into a
   list, shows a combined project total, and a "Send the whole project to Max" button. Isolated. */
(function(){
  function $(id){ return document.getElementById(id); }
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    var cta=document.querySelector('.wc-cta'); if(!cta || $('wcProj')) return;
    var money=function(n){ return '$'+Math.round(n).toLocaleString('en-US'); };
    var num=function(s){ return parseFloat(String(s).replace(/[^0-9.]/g,''))||0; };
    var t=function(id){ var e=$(id); return e?e.textContent.trim():''; };

    if(!$('wcProjCss')){
      var st=document.createElement('style'); st.id='wcProjCss';
      st.textContent='.wc-proj{flex-basis:100%;margin-top:8px;display:flex;flex-direction:column;gap:12px}'+
        '.wc-addwall{align-self:flex-start}'+
        '.wc-proj-box{border:1px solid var(--line);border-radius:16px;padding:18px 20px;background:var(--card)}'+
        '.wc-proj-h{display:flex;justify-content:space-between;align-items:baseline;margin-bottom:10px}'+
        '.wc-proj-h b{font-size:1.15rem;color:var(--ink)}'+
        '.wc-proj-h span{font-size:.9rem;color:var(--muted)}'+
        '.wc-proj-row{display:flex;justify-content:space-between;align-items:center;gap:10px;padding:10px 0;border-top:1px solid var(--line);font-size:.98rem;color:var(--ink)}'+
        '.wc-proj-row small{display:block;color:var(--muted);font-size:.82rem;margin-top:2px}'+
        '.wc-proj-row b{white-space:nowrap}'+
        '.wc-proj-x{border:0;background:rgba(0,0,0,.06);color:#6e6e73;width:26px;height:26px;border-radius:50%;cursor:pointer;font-size:1rem;line-height:1;flex:none}'+
        '.wc-proj-tot{display:flex;justify-content:space-between;align-items:baseline;margin-top:12px;padding-top:12px;border-top:2px solid var(--ink)}'+
        '.wc-proj-tot b{font-size:1.5rem;color:var(--blue-d)}';
      document.head.appendChild(st);
    }

    var wrap=document.createElement('div'); wrap.className='wc-proj'; wrap.id='wcProj';
    wrap.innerHTML='<button type="button" id="wcAddWall" class="lp-cta lp-cta--ghost lp-cta--lg wc-addwall">&#43; Add another wall to this project</button>'+
      '<div class="wc-proj-box" id="wcProjBox" hidden></div>';
    cta.parentNode.insertBefore(wrap, cta.nextSibling);

    var walls=[];
    function render(){
      var box=$('wcProjBox');
      if(!walls.length){ box.hidden=true; box.innerHTML=''; return; }
      box.hidden=false;
      var sum=walls.reduce(function(a,w){return a+w.total;},0), h='';
      h+='<div class="wc-proj-h"><b>Your project</b><span>'+walls.length+' wall'+(walls.length>1?'s':'')+'</span></div>';
      walls.forEach(function(w,i){
        h+='<div class="wc-proj-row"><div>Wall '+(i+1)+' &mdash; '+w.finish+'<small>'+w.size+' &middot; '+w.panels+' panels &middot; '+w.mode+'</small></div>'+
           '<b>'+money(w.total)+'</b> <button type="button" class="wc-proj-x" data-i="'+i+'" aria-label="Remove">&times;</button></div>';
      });
      h+='<div class="wc-proj-tot"><span>Project total</span><b>'+money(sum)+'</b></div>';
      h+='<a class="lp-cta lp-cta--lg" style="margin-top:14px" target="_blank" rel="noopener" href="'+waLink(sum)+'">Send the whole project to Max</a>';
      box.innerHTML=h;
      Array.prototype.forEach.call(box.querySelectorAll('.wc-proj-x'), function(b){
        b.addEventListener('click', function(){ walls.splice(+b.getAttribute('data-i'),1); render(); });
      });
    }
    function currentMode(){
      var on=document.querySelector('.wc-modeseg button.is-on');
      return on?on.getAttribute('data-mode'):'panels';
    }
    function modeLabel(m){ return m==='install'?'install only':(m==='combo'?'panels + install':'panels only'); }
    function waLink(sum){
      var msg='Hi Max! Here is my whole media-wall project ('+walls.length+' wall'+(walls.length>1?'s':'')+'):\n';
      walls.forEach(function(w,i){ msg+=(i+1)+') '+w.size+', '+w.finish+', '+w.panels+' panels, '+w.mode+' - '+money(w.total)+'\n'; });
      msg+='Project total '+money(walls.reduce(function(a,w){return a+w.total;},0))+'. Can you confirm and quote it?';
      return 'https://wa.me/14243457142?text='+encodeURIComponent(msg);
    }

    $('wcAddWall').addEventListener('click', function(){
      var size=t('wcWv')+' '+t('wcWunit')+' × '+t('wcHv')+' '+t('wcHunit');
      walls.push({ size:size, finish:t('wcFname'), panels:t('wcPanels'), total:num(t('wcPrice')), mode:modeLabel(currentMode()) });
      render();
      try{ $('wcProjBox').scrollIntoView({behavior:'smooth',block:'nearest'}); }catch(e){}
    });
  });
})();
